<template>
  <b-container v-if="forbidden">
    <ForbiddenBanner/>
  </b-container>
  <b-container v-else>
    <b-row class="text-left">
      <b-col>
        <h2>Organization</h2>
        <h5 class="text-secondary">{{ organization.name }}</h5>
      </b-col>
    </b-row>
    <b-alert :show="organization.uuid !== undefined && owners.length === 0" variant="warning" class="text-left mt-2">
      This organization has no Owner.
    </b-alert>
    <p v-if="owners.length > 0" class="text-left mt-2 mb-2">
      <strong>{{ owners.length === 1 ? 'Owner' : 'Owners' }}:</strong>
      {{ owners.map(owner => owner.name).join(', ') }}
    </p>
    <b-form v-if="isSuperAdmin" inline class="mb-2" @submit.prevent="onAddOwner">
      <b-form-input
          size="sm"
          class="mr-2"
          v-model="newOwner"
          placeholder="Email of the new Owner"
          autocomplete="off"
      />
      <b-button size="sm" variant="outline-primary" type="submit" :disabled="! newOwner">Add Owner</b-button>
    </b-form>
    <b-alert :show="ownerError !== ''" variant="danger" class="text-left">{{ ownerError }}</b-alert>
    <b-row class="border shadow-lg user-select-none bg-light text-left mt-2 pt-2 pb-2" align-v="center">
      <b-col md="7" lg="5">
        <b-form-input
            autofocus
            v-model="filter"
            placeholder="Search Teams"
            autocomplete="off"
        />
      </b-col>
    </b-row>
    <h4 class="text-left mt-3">Teams</h4>
    <b-table
        hover
        small
        :items="teams"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="['name']"
    />
    <!-- Runners are managed on Users and Teams: their teams, roles and whether they're active -->
  </b-container>
</template>

<script>

import ForbiddenBanner from "../components/ForbiddenBanner";
import ForbiddenContentMixin from "../components/ForbiddenContentMixin";
import GlobalDataMixin from "@/components/GlobalDataMixin";

export default {
  name: 'Organization',
  // GlobalDataMixin: isSuperAdmin, who can add Owners
  mixins: [ForbiddenContentMixin, GlobalDataMixin],
  components: {
    ForbiddenBanner,
  },
  props: {
    uuid: String,
    globalData: Object,
  },
  data() {
    return {
      organization: {},
      teams: [],
      owners: [],
      newOwner: '',
      ownerError: '',
      fields: [
        {key: "name", sortable: true, class: "text-truncate"},
        {key: "runners", sortable: true},
      ],
      filter: '',
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$http.get(`/api/groups/${this.uuid}`)
          .then(response => {
            this.organization = response.data.organization;
            this.teams = response.data.teams;
            this.owners = response.data.owners;
          })
          .catch(e => {
            this.HandleResponse(e);
          })
    },
    onAddOwner() {
      this.ownerError = '';
      this.$http.post(`/api/groups/${this.uuid}/owners`, {username: this.newOwner.trim()})
          .then(() => {
            this.newOwner = '';
            this.refresh();
          })
          .catch(e => {
            this.ownerError = (e.response && e.response.data) || 'The Owner could not be added';
            console.warn(e);
          })
    },
  }
}
</script>

<style scoped>
</style>
